// src/hooks/useInactivityTimeout.ts — Cierre automático de sesión por inactividad (POW-02 §4)
import { useEffect, useRef } from 'react'
import { useAuthStore } from '@/store/authStore'
import toast from 'react-hot-toast'

const INACTIVITY_MS = 30 * 60 * 1000 // 30 minutos por defecto (POW-02 §4.1)

export function useInactivityTimeout(timeoutMs = INACTIVITY_MS) {
  const { step, logout } = useAuthStore()
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    if (step !== 'authenticated') return

    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current)
      timerRef.current = setTimeout(async () => {
        toast.error('Tu sesión ha finalizado por inactividad (30 minutos).', { duration: 6000 })
        await logout()
      }, timeoutMs)
    }

    const events = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click']
    events.forEach((evt) => window.addEventListener(evt, resetTimer, { passive: true }))

    resetTimer()

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
      events.forEach((evt) => window.removeEventListener(evt, resetTimer))
    }
  }, [step, logout, timeoutMs])
}
